import React from "react";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { resolveErrorMessage } from "../../utils/resolveErrorMessage";
import { DeleteInstalledBaseIotReportSubscription } from "../../graphql/mutations/deleteInstalledBaseIotReportSubscription";
import ConfirmDeleteModal from "../ConfirmDeleteModal";

interface Props {
    open: boolean;
    subscriptionId: string;
    clientName?: string;
    onClose: () => void;
}

const DeleteIotReportSubscriptionModal = ({ open, subscriptionId, clientName, onClose }: Props) => {
    const { t } = useTranslation();

    const [deleteSubscription, { loading }] = useMutation(DeleteInstalledBaseIotReportSubscription, {
        refetchQueries: ["InstalledBaseIotReportSubscriptions"],
    });

    const handleConfirm = () => {
        deleteSubscription({ variables: { id: subscriptionId } })
            .then((res) => {
                if (res.data?.deleteInstalledBaseIotReportSubscription?.success === false) {
                    toast.error(
                        res.data.deleteInstalledBaseIotReportSubscription.message || t("Failed to delete subscription.")
                    );
                    return;
                }
                toast.success(t("Report subscription removed."));
                onClose();
            })
            .catch((err) => toast.error(resolveErrorMessage(err, t)));
    };

    return (
        <ConfirmDeleteModal
            open={open}
            loading={loading}
            onConfirm={handleConfirm}
            onClose={onClose}
            title={t("Delete report subscription")}
            message={
                clientName
                    ? t(
                          "Are you sure you want to permanently delete the IoT report subscription for {{name}}? This action cannot be undone.",
                          { name: clientName }
                      )
                    : t("Are you sure you want to permanently delete this subscription? This action cannot be undone.")
            }
        />
    );
};

export default DeleteIotReportSubscriptionModal;
